import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { PopoverTagsComponent } from '../popover-tags/popover-tags.component';
import { ShowTermsComponent } from '../show-terms/show-terms.component';
import { SliderImagesComponent } from 'src/app/pages/admin/componentsAdmin/slider-images/slider-images.component';
import { Platform } from '@ionic/angular';
import { LoginService } from 'src/app/services/login.service';

declare var grecaptcha: any;

@Component({
  selector: 'app-form-component',
  templateUrl: './form-component.component.html',
  styleUrls: ['./form-component.component.scss'],
})
export class FormComponentComponent implements OnInit, OnDestroy {
  @ViewChild('badge') set content(content) {
    if (content) {
      // initially setter gets called with undefined
      this.badge = content;
      this.existTag = true;
    }
  }
  @ViewChild('editor') editor;
  @ViewChild('sliderImagesContainer')
  sliderImagesContainer: SliderImagesComponent;
  @Input() isDispatch = false;
  @Input() titleForm: string = '';
  @Input() fieldForms: any[] = [];
  @Input() fullWidth = false;
  @Input() showGiftCards = true;
  @Input() interface = undefined;
  @Input() fitWidth = undefined;
  @Input() fullWidthSelect = false;
  @Input() showCaptcha = true;
  @Input() formName = '';
  @Input() saveInUpload = undefined;
  @Input() set savedForm(value) {
    if (value) {
      this.editForm = value;
      this.imagesUploaded = [];
      this.setForm();
    }
  }
  @Input() edit: any;
  @Input() showButton: boolean = false;
  @Input() ocultGift: boolean = false;
  @Input() clearButton: boolean = true;
  @Input() disabled: boolean = false;
  @Input() id = undefined;
  @Input() isCatalogue = false;
  @Input() buttonText = undefined; //Para poner un texto personalizado al boton del submit
  @Input() buttonSaveFullWidth: boolean;
  @Input() buttonClearFullWidth: boolean;
  @Input() buttonSaveStyle: string;
  @Input() buttonClearStyle: string;
  @Input() insertImg = true;
  @Input() totalAmountForGiftCard = 0;
  @Input() subscribeForm: boolean = true;
  @Output() sendInfo = new EventEmitter();
  @Output() emitSelectValue = new EventEmitter();
  @Output() emitRadioValue = new EventEmitter();
  @Output() clearInput = new EventEmitter();
  @Output() checkboxs = new EventEmitter();
  public ckeConfig: any;
  public editForm = undefined;
  public existTag = false;
  public badge = undefined;
  public imagesUploaded: any[] = undefined;
  public dinamicForm: FormGroup;
  public relations: any[] = [];
  public fixedArr = [];
  public longDescription = '';
  public tags = [];
  public files: any = undefined;
  public termsConfirm = undefined;
  public subscriptions: Subscription = new Subscription();
  public backupChildCategories: any[] = [];
  public editorObs = new Subscription();
  public uploadedFiles = undefined;
  private url = environment.url;
  public showDate = true;
  public actualDate = new Date().toISOString().split('T')[0];

  constructor(
    private fb: FormBuilder,
    private uiSv: UiServices,
    private fileSv: FileService,
    private formSv: FormServices,
    private renderer: Renderer2,
    private httpSv: HttpService,
    private translateSv: TranslateService,
    private platform: Platform,
    private loginSv: LoginService
  ) {}

  ngOnInit() {
    if (this.platform.is('capacitor') && this.platform.is('ios')) {
      this.showDate = true;
    }
    this.ckeConfig = { extraPlugins: environment.ckConfig };
    if (this.subscribeForm) {
      this.subscriptions.add(
        this.formSv.getDataObs.subscribe(() => {
          this.submitInfo();
        })
      );
    }

    this.buildForm();
    this.subscriptions.add(
      this.formSv.clearFormObs.subscribe((value) => {
        if (value === 'setUndefined') {
          this.dinamicForm = undefined;
        }
        if (value === 'reload' || value === undefined) this.resetForm();
      })
    );
  }

  setDate(ev, fieldName: string) {
    const date = new Date(ev).toISOString();
    this.dinamicForm.get(fieldName).setValue(date);
  }

  async uploadImg(ev) {
    try {
      const file = ev.target.files[0];
      const formData = new FormData();
      formData.append('ckEditor', file);
      formData.append('type', 'ckEditor');
      const res = await this.httpSv.itemAction(formData, 'images', 'store');
      if (res.status) {
        const imageRoute = `${this.url}/file/ckEditor/${res.data}`;
        this.longDescription += `<img src=${imageRoute}>`;
      }
      ev.target.value = null;
    } catch (err) {
      console.error(err);
    }
  }

  selectAll(item) {
    let ids = item.select.map((item) => item.id);
    item.allSelected && (ids = []);
    this.dinamicForm.get(item.fieldName).setValue(ids);
    item.allSelected = !item.allSelected;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  buildForm() {
    console.log('this.fieldForms', this.fieldForms);
    const obj = {};
    for (const item of this.fieldForms) {
      const field = item.fieldName;
      if (item.typeInput === 'file') {
        !this.files && (this.files = {});
        this.files[field] = [];
      }

      if (
        item.typeInput !== 'image' &&
        item.typeInput !== 'tags' &&
        item.typeInput !== 'avatar' &&
        item.typeInput !== 'file' &&
        item.typeInput !== 'captcha'
      ) {
        !obj[field] &&
          (obj[field] = [{ value: '', disabled: item.disable }, []]);
        if (item.typeInput === 'checkboxes') {
          obj[field][0] = [];
        }
        if (item.typeInput === 'checkbox' || item.typeInput === 'toggle') {
          obj[field] = [false, []];
        }

        if (item.typeInput.includes('checkbox-')) {
          obj[field] = [false, []];
        }

        if (field === 'termsConfirm') {
          this.termsConfirm = true;
        }

        if (item.isRequired) {
          obj[field][1].push(Validators.required);
        }

        if (
          item.fieldName.includes('email') &&
          item.fieldName !== 'emailViewId'
        ) {
          obj[field][1].push(
            Validators.pattern(/^[\w\.g]+@+[\w]+[.]+[\D]{2,10}$/)
          );
        }

        if (item?.select) {
          const value = this.findAndDisableInput(item);
          if (value[0]) {
            this.relations.push(...value);
          }
        }
      }
      if (item.fieldName === 'categoriesChild') {
        this.backupChildCategories = item.select;
        item.select = [];
      }
    }

    this.dinamicForm = this.fb.group(obj);
    this.controlInput();
    this.setForm();
  }

  setCheckboxes(ev, formName, checkbox, item?) {
    const id = ev.target.value;
    const data: any[] = this.dinamicForm.get(formName).value;
    const existId = !!data.find((item) => item === id);
    if (existId) {
      const newValues = data.filter((item) => item !== id);
      this.dinamicForm.get(formName).setValue(newValues);
    }
    this.checkboxs.emit({ existId, id, checkbox, item });
  }

  async setFile(ev, fieldName) {
    try {
      const files: any[] = ev.target.files;

      const uploadedFiles: any[] = await this.fileSv.uploadImages(files, true);
      await this.uiSv.showLoading();
      for (const item of uploadedFiles) {
        const formData = new FormData();
        formData.set(fieldName, item.file);
        formData.set('type', fieldName);
        const uploadFile: any = await this.httpSv.itemAction(
          formData,
          'images',
          'store'
        );
        this.files[fieldName].push(uploadFile);
      }
      this.fileSv.emptyArr();
      await this.uiSv.loading.dismiss();

      if (files.length > 1) this.uploadedFiles = uploadedFiles;
      else this.uploadedFiles = files[0];

      ev.target.value = null;
    } catch (err) {
      console.error(err);
    }
  }

  resetForm() {
    this.dinamicForm?.reset();
    setTimeout(() => {
      this.longDescription = '';
    });
    this.imagesUploaded = undefined;
    this.uploadedFiles = undefined;
    this.edit = undefined;
    this.editForm = undefined;
    this.id = undefined;
    this.files = undefined;
    this.clearInput.emit();
  }

  emitChange(ev, fieldName?) {
    const value = ev.detail.value;
    if (
      fieldName === 'categories' &&
      this.backupChildCategories.length &&
      value
    ) {
      this.verifyChildCategories(value, ev);
    }
    this.emitSelectValue.emit(value);
  }

  verifyChildCategories(value, ev) {
    let childCategorieBackup = this.fieldForms.find(
      (item) => item.fieldName === 'categoriesChild'
    );
    const parentCategories: any[] = this.fieldForms.find(
      (item) => item.fieldName === 'categories'
    ).select;
    childCategorieBackup.select = [];
    let childCategorie = [];
    value.map((item) => {
      const parentCategory = parentCategories.find(
        (category) => category.id === item
      );
      const categorie = this.backupChildCategories.filter((category) => {
        if (category.parentId === item) {
          if (!category.name.includes(parentCategory.name)) {
            category.name = `${parentCategory.name} - ${category.name}`;
          }
          return category;
        }
      });
      if (categorie) {
        childCategorie.unshift(...categorie);
      }
    });
    childCategorieBackup.select = childCategorie;
  }

  setForm() {
    if (this.editForm && this.dinamicForm) {
      if (this.editForm.isSalient) {
        this.editForm.salient = this.editForm.isSalient;
      }
      if (this.isCatalogue) {
        const file = { forntCatalogue: this.editForm.banner };
        const banner = { catalogues: this.editForm.file };
        this.edit = [banner, file];
      } else {
        this.edit = this.editForm.media;
        if (this.edit) {
          const video = this.edit.find((item) => item.isVideo === 1);
          if (video) {
            this.editForm.video =
              video.file !== 'null' ? video.file : undefined;
          }
        }
      }
      setTimeout(() => {
        if (!this.longDescription) {
          this.longDescription =
            this.editForm?.longDescription ||
            this.editForm?.description ||
            this.editForm?.html ||
            '';
          this.dinamicForm.value.longDescription = this.longDescription;
        }
      }, 250);
      this.tags = this.editForm?.tags?.split(' ') || [];
      if (this.editForm.parentId) {
        this.editForm.parentIdNull = true;
      }

      if (
        this.editForm.categories &&
        this.editForm.categories?.length &&
        this.backupChildCategories?.length
      ) {
        const subCategories = [];
        let categorie: any[] = [];
        this.editForm.categories.map((item: any) => {
          const principal = !this.backupChildCategories.find(
            (data) => data.id === item
          );
          if (principal) categorie.push(item);
          else subCategories.push(item);
        }, []);
        this.editForm.categoriesChild = subCategories;
        this.editForm.categories = categorie;
      }

      this.dinamicForm?.patchValue(this.editForm);
    }

    if (this.isDispatch && this.loginSv.user) {
      if (this.dinamicForm.get('nameClient')) {
        this.dinamicForm.get('nameClient').setValue(this.loginSv.user.name);
      }

      if (this.dinamicForm.get('email')) {
        this.dinamicForm.get('email').setValue(this.loginSv.user.email);
      }
    }
  }

  checkboxHandler(fieldName: string) {
    if (
      this.dinamicForm.get(fieldName).value === true &&
      this.editForm &&
      this.editForm[fieldName]
    ) {
      this.dinamicForm.get(fieldName).setValue(this.editForm[fieldName]);
    }
  }

  controlInput() {
    this.relations.forEach((item) => {
      const formInput = this.dinamicForm.get(item);
      if (formInput) {
        formInput.disable();
      }
    });
  }

  findAndDisableInput(item) {
    if (item?.select) {
      const values = item?.select?.map((input) => {
        if (input.relation) {
          return input.relation;
        }
      });
      return values;
    }
  }

  enabelForm(item, action) {
    const formInput = this.dinamicForm.get(item);
    if (action) {
      formInput.enable();
    } else {
      formInput.disable();
    }
  }

  setChange(ev, item, isCheckbox?) {
    const value = this.findAndDisableInput(item);
    const valueRadio = isCheckbox ? ev.detail.checked : ev.detail.value;
    this.emitRadioValue.emit(valueRadio);
    if (value && value[0]) {
      this.enabelForm(value[0], valueRadio ? true : false);
    }
  }

  async submitInfo(extraData?: string) {
    if (
      this.fieldForms.find((item) => item.typeInput === 'captcha') &&
      this.showCaptcha
    ) {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(environment.captchaKey, {
            action: 'submit',
          })
          .then((token) => {
            this.handleSubmit(extraData, token);
            // Add your logic to submit to your backend server here.
          });
      });
    } else {
      this.handleSubmit(extraData);
    }
  }

  async handleSubmit(extraData?: string, recaptchaToken?: string) {
    if (this.dinamicForm && this.dinamicForm?.invalid) {
      this.sendInfo.emit({ name: this.formName, value: false });
      const translate = this.translateSv.instant(
        'VERIFICA_QUE_LOS_DATOS_ESTEN_COMPLETOS'
      );
      await this.uiSv.showToast(translate);
      return this.dinamicForm.markAllAsTouched();
    } else if (
      this.termsConfirm &&
      !this.dinamicForm.get('termsConfirm').value
    ) {
      const translate = this.translateSv.instant(
        'DEBES_ACEPTAR_LOS_TERMINOS_Y_CONDICIONES_ANTES_DE_CONTINUAR'
      );
      return this.uiSv.showToast(translate);
    }

    if (
      this.dinamicForm?.get('confirmPassword') &&
      this.dinamicForm?.value?.confirmPassword !==
        this.dinamicForm?.value?.password
    ) {
      const translate = this.translateSv.instant(
        'VERIFICA_QUE_LAS_CONTRASEÑAS_SEAN_IGUALES'
      );
      return this.uiSv.showToast(translate);
    }
    const formData = new FormData();
    if (this.existTag) {
      formData.append('tags', this.tags?.join(' '));
    }
    if (this.imagesUploaded) {
      // let images: FormData = new FormData();
      if (this.isCatalogue) {
        this.imagesUploaded.map((item) => {
          const img: FormData = this.fileSv.fixArrayImg(
            item,
            this.saveInUpload
          );
          if (img) {
            img.forEach((item, key) => {
              formData.append(key, item);
              // images.append(key, item);
            });
          }
        });
      } else {
        this.imagesUploaded.forEach((x: any) => {
          const key = Object.keys(x)[0];
          formData.append(key, x[key].join(','));
        });
        // images = this.fileSv.fixArrayImg(
        //   this.imagesUploaded,
        //   this.saveInUpload
        // );
      }
      // images.forEach((item, key) => {
      //   formData.append(key, item);
      // });
    }
    if (this.dinamicForm?.value) {
      for (const key of Object.keys(this.dinamicForm?.value)) {
        let value = this.dinamicForm?.value[key];
        if (key !== 'files') {
          if (key === 'longDescription' && this.editor) {
            // this.editor.data = this.editor.data.replace(
            //   /sandbox=""/g,
            //   'sandbox="allow-scripts allow-same-origin"'
            // );
            value = this.editor.data;
          }

          formData.append(key, value);
        }
      }
    }

    if (this.files) {
      let data = '';
      for (const key of Object.keys(this.files)) {
        const value: any[] = this.files[key];
        for (const item of value) {
          data += `${item.data} `;
        }
        data = data.trim();
        data = data.replace(/ /g, ',');
        formData.append(key, data);
      }
    }
    formData.forEach((item, key) => {
      if (item === 'null') {
        item = JSON.stringify(null);
      } else if (item === 'false') {
        item = JSON.stringify(false);
      } else if (item === 'true') {
        item = JSON.stringify(true);
      }
    });

    if (extraData) {
      formData.set('extraData', extraData);
    }

    if (recaptchaToken) {
      formData.set('recaptchaToken', recaptchaToken);
    }
    this.sendInfo.emit(formData);
  }

  openModalDate(id, open) {
    const el: HTMLIonPopoverElement = document.getElementById(
      id
    ) as HTMLIonPopoverElement;
    el.isOpen = open;
  }

  saveImg(file) {
    if (this.isCatalogue) {
      !this.imagesUploaded && (this.imagesUploaded = []);
      if (file?.type) {
        if (!file.img[file.type].length) {
          const index = this.imagesUploaded.findIndex(
            (item) => item[file.type] === file.img[file.type]
          );
          this.imagesUploaded.splice(index, 1);
        }
      } else {
        this.imagesUploaded.push(file);
      }
    } else {
      if (file && Object.keys(file).length) {
        if (this.imagesUploaded && this.imagesUploaded.length) {
          const key = Object.keys(file);
          const images = this.imagesUploaded.find((x) => x[key[0]]);
          if (images) {
            images[key[0]] = file[key[0]];
          } else {
            this.imagesUploaded.push(file);
          }
        } else {
          this.imagesUploaded = [file];
        }
      }
    }
  }

  removeImg(ev) {
    let images = this.imagesUploaded.filter((x) => x[ev.type]?.length);
    if (!images.length) {
      this.imagesUploaded = this.imagesUploaded.filter((x) => !x[ev.type]);
    } else {
      images = images.filter((x) => x[ev.type] !== ev.img.url);
    }
  }

  setAnimBadge(tagInput) {
    this.fileSv.setAnimBadge(tagInput, this.badge, this.tags);
    this.renderer.addClass(this.badge.el, 'showBadge');
    setTimeout(() => {
      this.renderer.removeClass(this.badge.el, 'showBadge');
    }, 1000);
  }

  showTags() {
    this.uiSv.showPopover(PopoverTagsComponent, { tags: this.tags });
  }

  async setTerm(fieldName) {
    if (fieldName === 'termsConfirm') {
      const { data } = await this.uiSv.showModal(
        ShowTermsComponent,
        {},
        'modalAdmin'
      );
      if (data === 'accept') {
        this.dinamicForm.get(fieldName).setValue(true);
      } else {
        this.dinamicForm.get(fieldName).setValue(false);
      }
    }
  }
}
